export const colors = {
  black: "text-black",
  inherit: "text-inherit",
  primary: "text-primary",
  sharemaroon: "text-sharemaroon",
  white: "text-white",
  sharegraywhite: "text-sharegraywhite",
  sharedarkblue: "text-sharedarkblue",
  nightblack: "text-nightblack",
  sharedeepblue: "text-sharedeepblue",
  "blue-600": "text-blue-600",
  "c4blue-400": "text-c4blue-400",
  "gray-25": "text-grey-25",
  "c4blue-600": "text-c4blue-600",
  "gray-200": "text-gray-200",
  "gray-300": "text-gray-300",
  "gray-500": "text-gray-500",
  "gray-600": "text-gray-600",
  "c4red-400": "text-c4red-400",
  "green-400": "text-green-400",
  "green-500": "text-green-500",
  "green-600": "text-green-600",
  "red-400": "text-red-400",
  "gold-400": "text-gold-400",
  "red-500": "text-red-500",
  "red-600": "text-red-600",
  "persia-400": "text-persia-400",
};
